module.exports = __webpack_public_path__ + "static/media/arrow-down.b97108b0.svg";